<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card class="mb-3" title="Yeni Kitap Ekle">
                    <!-- <b-alert variant="warning" show class="mb-0">
                        <div class="alert-body mb-2">
                           <span><strong>Not:</strong> Eklenecek podcast bağlantı linki
                                benzersiz olmalıdır...</span>
                        </div>
                    </b-alert> -->
                    <b-button class="float-right" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                        to="/books">
                        Kitap Listesi
                    </b-button>
                </b-card>
            </b-col>
        </b-row>
        <validation-observer ref="rules">
            <b-row>
                <b-col cols="12">
                    <b-card class="mb-3" title="Kitap Ekleme Formu">
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="Kitap Adı" label-for="title">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="Kitap Adı">
                                        <b-form-input id="name" v-model="name" placeholder="Kitap Adı"
                                            :state="errors.length > 0 ? false : null"
                                            :class="name.length >= chars.name ? 'text-danger' : ''" />
                                        <small class="textarea-counter-value float-right"
                                            :class="name.length >= chars.name ? 'bg-danger' : ''">
                                            <span class="char-count">{{ name.length }}</span>
                                            /
                                            {{ chars.name }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Yazar" label-for="writer">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }" name="Yazar">
                                        <b-form-input id="writer" v-model="writer" placeholder="Yazar"
                                            :state="errors.length > 0 ? false : null" :class="writer.length >= chars.writer ? 'text-danger' : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="writer.length >= chars.writer ? 'bg-danger' : ''
                                            ">
                                            <span class="char-count">{{ writer.length }}</span>
                                            /
                                            {{ chars.writer }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" class="mt-5"></b-col>
                            <b-col md="6" class="mt-5">
                                <div>
                                    <b-button class="float-right mt-2" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                        variant="outline-success" @click="postConfirmText(false, false)">
                                        <b-spinner v-if="spinner === true && isDraft === false" small />
                                        {{
                                            spinner === true && isDraft === false
                                                ? "Yayınlanıyor"
                                                : "Yayınla"
                                        }}
                                    </b-button>
                                </div>
                                <div>
                                    <b-button class="float-right mt-2 mr-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                        variant="outline-warning" @click="postConfirmText(true, false)">
                                        <b-spinner v-if="spinner == true && isDraft == true" small />
                                        {{
                                            spinner == true && isDraft == true
                                                ? "Taslağa Kaydediliyor"
                                                : "Taslağa Kaydet"
                                        }}
                                    </b-button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </validation-observer>
    </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
    BImg,
    BRow,
    BCol,
    BTime,
    BCard,
    BCardText,
    BButton,
    BForm,
    BMedia,
    BAlert,
    BSpinner,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    BLink,
} from "bootstrap-vue";
import {
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
} from "@validations";

import settings from '../../../settings';
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
    components: {
        DragDropImage,
        BImg,
        BRow,
        BCol,
        BTime,
        BLink,
        BCard,
        BCardText,
        BButton,
        BForm,
        BSpinner,
        BAlert,
        BFormGroup,
        BFormInput,
        BInputGroup,
        BFormTextarea,
        BMedia,
        BMediaAside,
        BMediaBody,
        BFormFile,
        BFormDatepicker,
        BFormCheckbox,
        vSelect,
        ValidationProvider,
        ValidationObserver,
        required,
        email,
        confirmed,
        url,
        between,
        alpha,
        integer,
        password,
        min,
        digits,
        alphaDash,
        length,
    },
    directives: {
        Ripple,
    },
    mixins: [heightTransition],
    data() {
        return {
            name: "",
            writer: "",
            image: null,
            spinner: false,
            chars: {
                name: 255,
                writer: 255,
            },
        };
    },
    watch: {

    },
    methods: {
        postConfirmText(isDraft, preview) {
            this.isDraft = isDraft;
            this.$swal({
                title: "Kayıt?",
                text: "Yeni kitabı kaydetmek istediğinize emin misiniz?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Vazgeç!",
                confirmButtonText: "Kaydet!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.postSubmit(preview);
                }
            });
        },
        postSubmit(preview) {
            this.$refs.rules.validate().then((success) => {
                if (success) {
                    this.spinner = true;
                    let formData = new FormData();
                    formData.append("name", this.name);
                    formData.append("writer", this.writer);
                    endpoints
                        .postBooks(formData, this.$i18n.locale, () => { })
                        .then((data) => {
                            this.spinner = false;
                            if (preview == true) {
                                // window.open(`${settings.uiBaseUrl}/educators/preview/${this.slug}?hl=${this.$i18n.locale}`, '_blank');
                                window.open(`${settings.uiBaseUrl}/library?hl=${this.$i18n.locale}`, '_blank');
                            }
                            this.$swal({
                                icon: "success",
                                title: "Kayıt başarılı!",
                                text: "Yeni kitap eklendi.",
                                customClass: {
                                    confirmButton: "btn btn-success",
                                },
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push({
                                        path: `/books`,
                                    });
                                }
                            });
                        })
                        .catch((err) => {
                            this.spinner = false;
                            console.log(err);
                        });
                }
            });
        },
    },
    created() { },
    destroyed() { },
    mounted() { },
    setup() { },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>